$('.locations select').on('change', function() {
	$(this).parents('form').submit();
});
